import { MapCategoriesStepContent } from "components/ChartOfAccounts/ImportCOA/MapCategoriesStep";
import Modal from "components/DesignSystem/Modal/Modal";
import { IMPORT_SOURCE } from "constants/qboImportSteps";
import { useImportFinally } from "./ImportFinallyContext";
import { ImportFinallyHeader } from "./ImportFinallyHeader";

type FinallyMapCategoriesStepProps = {
  importProcessId: string;
};

export const FinallyMapCategoriesStep = ({
  importProcessId,
}: FinallyMapCategoriesStepProps) => {
  const {
    entityId,
    onNext,
    categoryMapFormValues,
    setCategoryMapFormValues,
    isOpen,
    close,
  } = useImportFinally();

  const handleOpenChange = () => close({ takeConfirmation: true });

  return (
    <Modal.Root open={isOpen} onOpenChange={handleOpenChange} modal={false}>
      <Modal.Content size="xl" useCustomOverlay>
        <MapCategoriesStepContent
          onNext={onNext}
          importProcessId={importProcessId}
          entityId={entityId}
          header={<ImportFinallyHeader />}
          initialValues={categoryMapFormValues || undefined}
          onFormValuesChange={setCategoryMapFormValues}
          source={IMPORT_SOURCE.FINALLY}
          shouldDefaultUnmatchedToNone
        />
      </Modal.Content>
    </Modal.Root>
  );
};
